import React from 'react';
import styled, { ThemeProvider, withTheme } from 'styled-components';

const List = styled.div`
  display: flex;
`;

const SwatchGroup = ({
  theme, children, selectedTheme, selectTheme,
}) => {
  const swatches = React.Children.map(children, child =>
    React.cloneElement(child, { selected: child.props.value === selectedTheme, selectTheme }));
  return (
    <ThemeProvider theme={theme}>
      <List>{swatches}</List>
    </ThemeProvider>
  );
};

export default withTheme(SwatchGroup);



// WEBPACK FOOTER //
// ./src/components/SwatchGroup.js